/* fc-pp-sticky-cart.js (2026-10-12 speed pass): the sticky cart FAB (label sync, menu, add via fetch, scroll-lock watchdog, visibility).
   Moved out of sections/fc-pp-sticky-cart.liquid so browsers cache it across product
   pages; the root is #fc-stk and per-instance values travel as data
   attributes (or the JSON config script). The bodies are the former inline
   scripts, unchanged apart from those lookups. Re-initialises on
   shopify:section:load for the theme editor. */
(function () {
  'use strict';
  function initStickyCart(root) {


  var jsonEl = root.querySelector('[data-stk-product-json]');
  var variants = [];
  try { variants = JSON.parse(jsonEl.textContent); } catch (e) { variants = []; }

  var labelEl       = root.querySelector('[data-stk-label]');
  var ctaBtn        = root.querySelector('[data-stk-cta]');
  var menuEl        = root.querySelector('[data-stk-menu]');
  var menuAddBtn    = root.querySelector('[data-stk-menu-add]');
  var menuAddText   = root.querySelector('[data-stk-menu-add-text]');

  var unavailableText = root.getAttribute('data-fc-t-unavailable') || 'Unavailable';
  var soldOutText     = root.getAttribute('data-fc-t-soldout') || 'Sold out';
  var addText         = root.getAttribute('data-fc-t-add') || 'Add to cart';
  var addedText       = root.getAttribute('data-fc-t-added') || '✓ Added';
  // Phone bar (2026-10-13): one-tap add, label mirrors the main button, price follows the variant.
  var barEl      = root.querySelector('[data-stk-bar]');
  var barBtn     = root.querySelector('[data-stk-bar-add]');
  var barLabel   = root.querySelector('[data-stk-bar-label]');
  var barPrice   = root.querySelector('[data-stk-bar-price]');
  var barVariant = root.querySelector('[data-stk-bar-variant]');
  var barImg     = root.querySelector('[data-stk-bar-img]');
  function barMoney(cents){
    if (typeof window.fcMoney === 'function') return window.fcMoney(cents);
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  // ----- Find the main product form (Dawn AND FC custom form patterns) -----
  function getMainVariantInput() {
    var inputs = document.querySelectorAll('input[name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      if (root.contains(inputs[i])) continue;
      if (inputs[i].closest('cart-drawer, quick-add-modal')) continue;
      return inputs[i];
    }
    return null;
  }
  function getMainForm() {
    var input = getMainVariantInput();
    return input ? input.closest('form') : null;
  }
  function getMainAddButton() {
    var f = getMainForm();
    if (!f) return null;
    return f.querySelector('[data-fc-atc]')
        || f.querySelector('[data-fc-submit]')
        || f.querySelector('button[name="add"]')
        || f.querySelector('button[type="submit"]');
  }

  // ----- Sync state from main form -----
  function syncFromMain() {
    var input = getMainVariantInput();
    if (!input) return;
    var vid = parseInt(input.value, 10);
    var v = null;
    if (vid) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === vid) { v = variants[i]; break; }
      }
    }
    // Per-market stock gate (2026-09-18): fc-pp-info exposes variantId →
    // local warehouse units for AU/US shoppers (gated variants only). 0 =
    // sold out in THIS market even though Shopify's flag says available.
    var gm = window.__fcpp && window.__fcpp.gateMap;
    if (v && gm && typeof gm === 'object' && Object.prototype.hasOwnProperty.call(gm, String(v.id)) && !(Number(gm[v.id]) >= 1)) {
      v = { id: v.id, available: false };
    }

    var mainBtn = getMainAddButton();
    var disabled = mainBtn ? mainBtn.hasAttribute('disabled') : (!v || !v.available);

    // The FAB itself is always enabled (so users can still tap to "View Cart")
    // — only the "Add to Cart" menu item is disabled when the variant isn't available.
    if (menuAddBtn) {
      if (disabled) menuAddBtn.setAttribute('disabled', 'disabled');
      else menuAddBtn.removeAttribute('disabled');
    }

    var newLabel;
    if (v && !v.available) newLabel = soldOutText;
    else if (!v) newLabel = unavailableText;
    else {
      newLabel = addText;
    }

    if (labelEl) labelEl.textContent = newLabel;
    if (menuAddText) menuAddText.textContent = newLabel;

    // Phone bar: same availability; the label copies the main button's own
    // text when it has one (Add to cart / Pre-order / Sold out, already
    // localised), the price is the variant's (pre-order preview price when the
    // main price shows one), the thumbnail is the variant's image.
    if (barBtn) {
      if (disabled) barBtn.setAttribute('disabled', 'disabled'); else barBtn.removeAttribute('disabled');
      var mainLbl = mainBtn && mainBtn.querySelector('.fc-pp__cta-label');
      var txt = (mainLbl && mainLbl.textContent.trim()) || newLabel;
      if (barLabel && barBtn.dataset.success !== 'true') barLabel.textContent = txt;
      if (barPrice) {
        var mainPrice = document.querySelector('.fc-pp__price [data-fc-price]');
        var pTxt = mainPrice ? mainPrice.textContent.trim().replace(/\s+[A-Z]{3}$/, '') : '';
        if (!pTxt && v && typeof v.price === 'number') pTxt = barMoney(v.price);
        barPrice.textContent = (v && v.available !== false) ? pTxt : '';
      }
      if (barVariant && v && v.title) barVariant.textContent = v.title === 'Default Title' ? '' : v.title;
      if (barImg && v && v.featured_image && v.featured_image.src) {
        var src = String(v.featured_image.src).replace(/([?&])width=\d+&?/i, '$1').replace(/[?&]$/, '');
        src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        if (barImg.getAttribute('src') !== src) barImg.setAttribute('src', src);
      }
    }
  }

  // ----- Popover menu open/close -----
  function openMenu() {
    if (!menuEl) return;
    menuEl.setAttribute('data-open', 'true');
    ctaBtn.setAttribute('aria-expanded', 'true');
  }
  function closeMenu() {
    if (!menuEl) return;
    menuEl.setAttribute('data-open', 'false');
    ctaBtn.setAttribute('aria-expanded', 'false');
  }
  function isMenuOpen() {
    return menuEl && menuEl.getAttribute('data-open') === 'true';
  }
  function toggleMenu() {
    if (isMenuOpen()) closeMenu(); else openMenu();
  }

  // FAB click → toggle the menu (no longer adds to cart directly)
  ctaBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    if (ctaBtn.dataset.loading === 'true') return;
    toggleMenu();
  });

  // Outside click closes the menu
  document.addEventListener('click', function(e) {
    if (!isMenuOpen()) return;
    if (root.contains(e.target)) return;
    closeMenu();
  });

  // Chat → open the Shopify Inbox window. Its own launcher is hidden
  // site-wide (theme.liquid) so this item is the PDP entry point. The
  // widget has no official public JS API — click its hidden launcher
  // across the DOM shapes different Inbox versions render (including
  // shadow DOM hosts). If the widget never mounted, hide the menu item.
  (function () {
    var chatBtn = root.querySelector('[data-stk-chat]');
    if (!chatBtn) return;
    function inboxAvailable() {
      if (typeof window.__fcOpenInboxChat === 'function') return true;
      return !!document.querySelector('shopify-chat, #ShopifyChat, #shopify-chat, #dummy-chat-button-iframe');
    }
    chatBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeMenu();
      // Verified opener from theme.liquid (clicks the hidden
      // button.activator inside <shopify-chat>'s open shadow root).
      if (typeof window.__fcOpenInboxChat === 'function' && window.__fcOpenInboxChat()) return;
      // Legacy widget builds:
      var legacy = document.querySelector('#ShopifyChat button[aria-controls="chat-ui"], #shopify-chat > button, #dummy-chat-button-iframe');
      if (legacy) { try { legacy.click(); } catch (err) {} }
    });
    // The widget loads late; give it a few seconds before deciding it's
    // absent (embed disabled / blocked) and hiding the menu item.
    setTimeout(function () {
      if (!inboxAvailable()) chatBtn.style.display = 'none';
    }, 8000);
  })();
  // ESC closes the menu
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isMenuOpen()) {
      closeMenu();
      ctaBtn.focus();
    }
  });

  // ----- Scroll-lock watchdog -----
  // Aggressively detects and unwinds ANY scroll-lock applied to <body> or
  // <html> within a short window after add-to-cart. Catches:
  //   1. inline `position: fixed; top: -<scrollY>px`  (fc-pp-info bundle sheet)
  //   2. `overflow: hidden` on body or html (Dawn cart-drawer + many apps)
  //   3. body classes like `overflow-hidden` / `overflow-hidden-tablet` (Dawn)
  function installScrollLockWatchdog(savedScrollY, durationMs) {
    function unwindIfLocked() {
      var body = document.body;
      var html = document.documentElement;
      var hasInlineLock =
        body.style.position === 'fixed' ||
        body.style.overflow === 'hidden' ||
        html.style.overflow === 'hidden';
      var hasClassLock = /\boverflow-hidden(?:-\w+)?\b/.test(body.className);
      if (!hasInlineLock && !hasClassLock) return;

      var stashedY = parseInt((body.style.top || '0').replace('px', ''), 10) || 0;
      var restoreY = stashedY < 0 ? -stashedY : savedScrollY;

      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      body.style.overflow = '';
      html.style.overflow = '';

      body.className = body.className
        .split(/\s+/)
        .filter(function(c) { return !/^overflow-hidden(?:-\w+)?$/.test(c); })
        .join(' ');

      window.scrollTo(0, restoreY);
    }

    unwindIfLocked();

    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(unwindIfLocked);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style', 'class'],
    });

    var pollInterval = setInterval(unwindIfLocked, 80);
    setTimeout(function() {
      observer.disconnect();
      clearInterval(pollInterval);
    }, durationMs);
  }

  // ----- "Add to Cart" menu item: own /cart/add.js fetch -----
  // Critical: do NOT click the main form's submit button. fc-pp-info's submit
  // is a native type="submit" with no JS handler, so a programmatic click would
  // trigger a real form POST and navigate the page to /cart.
  function addSelectedToCart(trigger) {
      if (ctaBtn.dataset.loading === 'true') return;
      var input = getMainVariantInput();
      if (!input) return;
      var vid = parseInt(input.value, 10);
      if (!vid) return;

      ctaBtn.dataset.loading = 'true';
      if (barBtn) barBtn.dataset.loading = 'true';
      // Close the menu while the request is in flight so the loading spinner
      // is visible on the FAB.
      closeMenu();

      var savedScrollY = window.pageYOffset || window.scrollY || 0;

      var fd = new FormData();
      fd.append('id', String(vid));
      fd.append('quantity', '1');
      fd.append('form_type', 'product');

      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function(r) {
          if (!r.ok) throw new Error('Add failed: ' + r.status);
          return r.json();
        })
        .then(function(response) {
          ctaBtn.removeAttribute('data-loading');
          ctaBtn.dataset.success = 'true';
          setTimeout(function() { ctaBtn.removeAttribute('data-success'); }, 1400);
          if (barBtn) {
            barBtn.removeAttribute('data-loading');
            barBtn.dataset.success = 'true';
            if (barLabel) barLabel.textContent = addedText;
            setTimeout(function() { barBtn.removeAttribute('data-success'); syncFromMain(); }, 1600);
          }

          installScrollLockWatchdog(savedScrollY, 2500);

          document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));

          if (window.FoldifyCart && typeof window.FoldifyCart.show === 'function') {
            window.FoldifyCart.show(response);
          }
          // Deliberately no cart-drawer fallback — it adds `overflow-hidden`
          // to body which is the most likely scroll-lock culprit.
        })
        .catch(function(err) {
          ctaBtn.removeAttribute('data-loading');
          if (barBtn) barBtn.removeAttribute('data-loading');
          console.error('[fc-sticky-cart] add failed', err);
          var shakeEl = trigger === 'bar' && barBtn ? barBtn : ctaBtn;
          shakeEl.style.animation = 'fc-stk-shake .35s';
          setTimeout(function() { shakeEl.style.animation = ''; }, 400);
        });
  }
  if (menuAddBtn) {
    menuAddBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (menuAddBtn.hasAttribute('disabled')) return;
      addSelectedToCart('menu');
    });
  }
  if (barBtn) {
    barBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (barBtn.hasAttribute('disabled')) return;
      addSelectedToCart('bar');
    });
  }

  // ----- Variant change detection -----
  var lastSeenId = null;
  function checkAndSync() {
    var input = getMainVariantInput();
    if (!input) return;
    if (input.value !== lastSeenId) {
      lastSeenId = input.value;
      syncFromMain();
    }
  }
  document.addEventListener('change', function() {
    setTimeout(checkAndSync, 0);
  });
  document.addEventListener('click', function(e) {
    if (e.target.closest('label, [data-option-value], [data-fc-option], [data-variant-option-value]')) {
      setTimeout(checkAndSync, 30);
    }
  });

  // FC sections dispatch cart:updated after a successful add → success pulse
  document.addEventListener('cart:updated', function() {
    ctaBtn.removeAttribute('data-loading');
    ctaBtn.dataset.success = 'true';
    setTimeout(function() { ctaBtn.removeAttribute('data-success'); }, 1400);
    if (barBtn) barBtn.removeAttribute('data-loading');
  });
  // The main price repaints after a variant change (fc-pp-info.js): mirror it.
  document.addEventListener('fc:variant:change', function() { setTimeout(syncFromMain, 0); });
  document.addEventListener('cart:refresh', syncFromMain);

  // ----- Visibility: hide when main button in viewport -----
  function setupObserver() {
    var mainBtn = getMainAddButton();
    if (!mainBtn) {
      setTimeout(setupObserver, 250);
      return;
    }
    if (!('IntersectionObserver' in window)) {
      root.dataset.visible = 'true';
      document.body.classList.add('fc-stk-active');
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var inView = entry.isIntersecting;
        root.dataset.visible = inView ? 'false' : 'true';
        document.body.classList.toggle('fc-stk-active', !inView);
        // If the FAB scrolls out of view (because main button became visible),
        // close any open menu so it doesn't reappear stale on next show.
        if (inView) closeMenu();
      });
    }, { root: null, threshold: 0.1 });
    io.observe(mainBtn);
  }

  // ----- Init -----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      syncFromMain();
      setupObserver();
    });
  } else {
    syncFromMain();
    setupObserver();
  }
  }
  function init() {
    var root = document.getElementById('fc-stk');
    if (!root || root.getAttribute('data-fc-init') === '1') return;
    root.setAttribute('data-fc-init', '1');
    initStickyCart(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#fc-stk')) init();
  });
})();
